var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData } from "../../../utils/api/dataAccess";
// Get all varieties
export const getVarieties = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Varieties/varieties`;
    return getData(url);
});
//Note: This gets the varieties from VarietyCode.
export const getVarietyCodesByTrial = (trialId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `VarietyCodes/varietyCodes-bytrial` + `?trialId=${trialId}`;
    return getData(url);
});
// Create a new variety
export const createVariety = (variety) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Varieties/Varieties-create`;
    return createData(url, variety);
});
// Update an existing variety in a trial
export const updateVarietyCode = (variety) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `VarietyCodes/varietyCodes-update-bytrial`;
    return updateData(url, variety);
});
// Update an existing variety
export const updateVariety = (variety) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Varieties/variety-update`;
    return updateData(url, variety);
});
// Delete a variety
export const deleteVariety = (variety) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Varieties/Varieties-delete`;
    return updateData(url, variety);
});
//=========================================================================================================
// VARIETY CODES
//=========================================================================================================
// Get all variety codes
export const getVarietyCodes = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `VarietyCodes/VarietyCodes`;
    return getData(url);
});
